import { useParams } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { RouteProvider } from 'modules/contracts/pages/ContractVersionsPage/_RouteContext'

const EmployeeContractPage = () => {
  const { navigation } = useNavigation()
  const { id: employeeId } = useParams()
  const baseRoute = employeeId
    ? {
        contractVersionPath: (contractVersionId: string) =>
          navigation.employees.id.contractVersions.contractVersionId.fullPath({
            id: employeeId,
            contractVersionId,
          }),
      }
    : {}

  return (
    <RouteProvider baseRoute={baseRoute}>
      <Outlet />
    </RouteProvider>
  )
}

export default EmployeeContractPage
